module.exports = "<header></header>\n\n<div class=\"pageContent\">\n  <ui-view name=\"main\"></ui-view>\n</div>\n\n<ui-view></ui-view>\n<!-- <profile></profile> -->"


//////////////////
// WEBPACK FOOTER
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1